import { render } from "./HipismoTables.vue?vue&type=template&id=44f5be83"
import script from "./HipismoTables.vue?vue&type=script&lang=js"
export * from "./HipismoTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__